import {SensorStatus} from "dto/realdevice/devices"

// API Response 타입 (백엔드 실제 응답)
export interface PathTrackingResponse {
    id: number,
    eui: string,
    lat?: string,
    lng?: string,
    gradient?: Gradient,
    impact?: Impact,
    battery?: Battery,
    receivedDate: Date,
    receivedAt: Date,
    status?: DeterminedDeviceStatus,
    sensorStatus: SensorStatus,
}

// Domain 타입 (애플리케이션 내부 사용)
export interface PathTracking {
    id: number,
    eui: string,
    lat?: number,
    lng?: number,
    gradient?: Gradient,
    impact?: Impact,
    battery?: Battery,
    receivedDate: Date,
    receivedAt: Date,
    status?: DeterminedDeviceStatus,
    sensorStatus: SensorStatus,
}

interface DeterminedDeviceStatus {
    status: DeviceStatus,
    message?: string,
}
type DeviceStatus = "STAND_BY" | "COMMUNICATION_ERR"| "WORKING" | "EMERGENCY"

interface Gradient {
    x: number,
    y: number,
}

interface Impact {
    x: number,
    y: number,
}
interface Battery {
    level: number
}

// Response → Domain 변환 함수
export const toPathTracking = (response: PathTrackingResponse): PathTracking => ({
    ...response,
    lat: response.lat ? parseFloat(response.lat) : undefined,
    lng: response.lng ? parseFloat(response.lng) : undefined,
})